import React from 'react';
import { Link } from 'react-router-dom';
import { FileText, Heart } from 'lucide-react';

function Footer() {
  return (
    <footer className="bg-slate-900 border-t border-slate-800 mt-auto">
      <div className="max-w-7xl mx-auto px-4 py-4 sm:py-6">
        {/* Mobile: Stack vertical */}
        <div className="flex flex-col items-center gap-3 sm:hidden">
          <Link 
            to="/updates" 
            className="flex items-center text-sm text-gray-400 hover:text-indigo-500 transition group"
            title="Voir les notes de version"
          >
            <FileText size={14} className="mr-1.5 group-hover:scale-110 transition-transform" />
            Updates
          </Link>
          
          <div className="flex items-center text-xs text-gray-500 gap-1">
            <span>© 2025 Run Clubs</span>
            <span>•</span>
            <span className="flex items-center gap-1">
              Fait avec <Heart size={12} className="text-red-500 fill-red-500" /> pour la communauté
            </span>
          </div>
        </div>

        {/* Tablet & Desktop: Horizontal layout */}
        <div className="hidden sm:flex items-center justify-between text-sm">
          <div className="flex items-center gap-3 md:gap-4">
            <p className="text-gray-500">© 2025 Run Clubs</p>
            <span className="text-slate-700">•</span>
            <Link 
              to="/updates" 
              className="flex items-center text-gray-400 hover:text-indigo-500 transition group"
              title="Voir les notes de version"
            >
              <FileText size={14} className="mr-1.5 group-hover:scale-110 transition-transform" />
              <span className="hidden md:inline">Updates</span>
              <span className="md:hidden">Updates</span>
            </Link>
          </div>
          
          <div className="flex items-center gap-1 text-xs text-gray-500">
            <span className="hidden lg:inline">Fait avec</span>
            <Heart size={12} className="text-red-500 fill-red-500" />
            <span className="hidden lg:inline">pour la communauté running</span>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;